// extracted by mini-css-extract-plugin
export default {"container":"description-list_container__kNk1T","entry":"description-list_entry__Z0aSq","description":"description-list_description__+vQFU"};